import { render, staticRenderFns } from "./SearchWidgetResultsList.vue?vue&type=template&id=ab929770&"
import script from "./SearchWidgetResultsList.vue?vue&type=script&lang=js&"
export * from "./SearchWidgetResultsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports